import { ListChecks, Broom, GraduationCap } from "@phosphor-icons/react";

export const PHASE_META = {
  fundamentals: { title: "Bookkeeping Basics", icon: GraduationCap, color: "#6E7F5B", desc: "Registration, T-accounts, debits/credits & finding errors." },
  setup: { title: "Start the Books", icon: ListChecks, color: "#D96C4A", desc: "Foundation, system & chart of accounts." },
  cleanup: { title: "Clean Up the Books", icon: Broom, color: "#8A6A3B", desc: "Reconcile, categorize, verify & close — inside IronRoot." },
};

export const PHASE_ORDER = ["fundamentals", "setup", "cleanup"];

export function ProgressBar({ done, total }) {
  const pct = total ? Math.round((done / total) * 100) : 0;
  return (
    <div>
      <div className="flex justify-between text-xs mb-1.5" style={{ color: "var(--bk-text-2)" }}>
        <span className="font-medium">{done}/{total} steps</span>
        <span className="font-semibold">{pct}%</span>
      </div>
      <div className="h-2 rounded-full overflow-hidden" style={{ background: "var(--bk-border)" }}>
        <div
          className="h-full rounded-full"
          style={{ width: `${pct}%`, background: "var(--bk-success)", transition: "width 0.4s ease" }}
        />
      </div>
    </div>
  );
}
